import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import './Header.css';
import logo from '../../assets/vbc-logo.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-brand">
          <motion.img
            src={logo}
            alt="VBC Services LTD"
            className="header-logo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          />
        </div>
        <nav className="header-nav">
          <div className="nav-links">
            <motion.a href="#shop" className="nav-link" whileHover={{ scale: 1.05 }}>Shop</motion.a>
            <motion.a href="#contact" className="nav-link" whileHover={{ scale: 1.05 }}>Contact</motion.a>
          </div>
          <motion.a href="#shop" className="header-cta" whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            Bulk Deals
          </motion.a>
        </nav>
        <motion.div
          className="hamburger"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <Menu className="hamburger-menu" size={24} />
          <X className="hamburger-close" size={24} />
        </motion.div>
        <motion.div
          className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}
          initial={{ right: '-100%' }}
          animate={{ right: isMobileMenuOpen ? 0 : '-100%' }}
          transition={{ duration: 0.3 }}
        >
          <motion.a href="#shop" className="mobile-nav-link" whileHover={{ scale: 1.05 }}>Shop</motion.a>
          <motion.a href="#contact" className="mobile-nav-link" whileHover={{ scale: 1.05 }}>Contact</motion.a>
          <motion.a href="#shop" className="header-cta" whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
            Bulk Deals
          </motion.a>
        </motion.div>
      </div>
    </header>
  );
};

export default Header;